module.exports = __webpack_public_path__ + "img/specialist.d217d804.svg";